import { LocaleKey } from '@Locale/locale.ts';
import { isEmpty } from '@Util/stringUtils.ts';

export function getValidationMessageDigitsOnly(ssn: string): LocaleKey | '' {
    if (/[\D]/.test(ssn)) {
        return 'text_social_security_number_11_digits';
    } else {
        return '';
    }
}

export function getValidationPwd(pwd: string): LocaleKey | '' {
    if (isEmpty(pwd)) {
        return 'validation_missing';
    }
    return '';
}

export function getValidationSSN(nationalIdentityNumber: string): LocaleKey | '' {
    if (!nationalIdentityNumber || nationalIdentityNumber.length === 0) {
        return 'validation_missing';
    } else if (/[\D]/.test(nationalIdentityNumber)) {
        return 'text_social_security_number_11_digits';
    } else {
        return '';
    }
}
